export default {"src":"/_next/static/media/discount_64.159adb11.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};